/* eslint-disable max-len */
import * as React from 'react';
import { ScrollToTopButton, ScrollToTopOnMount } from '../scrolltotop';

export const HouseRules = () => (
  <>
    <ScrollToTopOnMount />
    <div className={'content_page'}>
      <h1>Huisregels</h1>
      <div className={'text_block'}>
        <p>
            Welkom op Dumpert, het allercoolste filmpjesportal van Nederland. Leuk dat u er bent. U maakt Dumpert tot wat het is. Hier vindt u alle bizarre, grappige, schandalige en maffe video's van het internet. Kijk gerust rond op de website. U mag overal aanzitten. U kunt zelfs een comment plaatsen. Het zogeheten reaguren is echter niet vrijblijvend. We hebben te maken met wettelijke regels en daarnaast hebben we zelf zo onze idee&euml;n over wat we wel en niet toestaan. Dumpert is ons kindje. We laten de sfeer niet door vervelio's verpesten. Reaguren betekent niet hetzelfde als een open platform. Daarom ziet u soms ergens <strong>-weggejorist-</strong> staan. Dat betekent dat uw reaguursel niet door de beugel kan. Een ban ziet er zo uit: <strong>-weggejorist en opgerot-</strong>. Bent u het er niet mee eens? Iedereen kan op een laagdrempelige manier een heersende videoportal beginnen, dus als u het allemaal maar belachelijk vindt, raden we u aan zelf een youtube-, tumbler- en/of blogspot-accountje aan te maken.
        </p>
      </div>
      <div className={'text_block'} data-columns="2">
        <h2>Vuistregel</h2>
        <p>
          Bedenk alvorens u meedoet of uw reactie of upload ook informatief
          en/of vermakelijk is voor anderen!
        </p>

        <h2>Klachten</h2>
        <p>
            Heb je een klacht over een bepaald filmpje of foto? Dat verbaast ons niks, daar ben je Nederlander voor. Stuur dan een mailtje naar <a href="mailto:gezeur@dumpert.nl?subject=Verwijderen%20van%20Dumpert&amp;body=Hallo%20Dumpert!%0A%0AMijn%20naam%3A%0AMijn%20email%3A%20%0AMijn%20telefoonnummer%3A%0ALink%20naar%20filmpje%2Ffoto%3A%20%0A%0AIk%20wil%20dit%20verwijderd%20hebben%20omdat%3A%0A%0ADesondanks%20wil%20ik%20graag%20zeggen%20dat%20ik%20de%20allergrootste%20dumpertfan%20ben%2C%20ga%20vooral%20zo%20door!%0A%0AGroetjes%2C%20%3Cnaam%3E" target="_blank" rel="noopener noreferrer">
            gezeur@dumpert.nl
          </a> of bel naar <a href="tel:+31622443318" target="_blank" rel="noopener noreferrer">06 2244 3318</a>. <strong>
            VERGEET NIET
          </strong> de volgende gegevens mee te sturen, anders nemen we je klacht simpelweg niet in behandeling.
        </p>
        <ul>
          <li>je naam, e-mailadres en telefoonnummer</li>
          <li>
            om welke content het gaat, inclusief de exacte URL van de pagina
            waarop de betreffende content gepubliceerd is de reden dat deze
            content verwijderd zou moeten worden
          </li>
          <li>jouw relatie tot deze content (voor zover van toepassing)</li>
        </ul>
        <p />

        <h3>WAT WE NIET TOESTAAN</h3>
        <p>En u een ip-ban oplevert</p>

        <h3>Kaalkopjes</h3>
        <p>
          Racisme, antisemitisme, rabiaat extreem-rechts taalgebruik en
          bedreigingen.
        </p>

        <h3>Trollen</h3>
        <p>
          Posten onder verschillende namen met de bedoeling een discussie
          een bepaalde kant op te sturen, simpelweg 'trollen' genoemd.
          Gebruikt u een proxy, of wegwerpadressen, dan kan het zijn dat we
          aannemen dat u minder goede bedoelingen heeft.
        </p>

        <h3>Analfabeten</h3>
        <p>
          Tenenkrommende taal- en spelfouten leveren u een ban op. Lees uw
          reactie terug alvorens te posten. Het (veelvuldig) gebruik van
          caps maakt u een schreeuwlelijk. Dit kan u een joris of ban
          opleveren. Het gebruik van emoji's waarderen we niet en ook dat
          kan u een joris of ban bezorgen.
        </p>

        <h3>Vervelio's</h3>
        <p>
          We staan dagelijks bloot aan veel kritiek. Kritiek is goed, we
          zullen u niet de mond snoeren vanwege inhoudelijke kritiek, maar
          vertel wel eens wat nieuws. Aanhoudende zeikreacties van
          hatertjes, niet bedoeld om een discussie te entameren, maar wel om
          Dumpert te beschadigen of de sfeer te verpesten zijn niet lief. We
          zitten niet te wachten op reacties die melden dat vroeger alles
          beter was. Daarnaast is Dumpert ons speeltje. 'Waarom staat dit op
          Dumpert?' en 'Dit is niet Dumpertwaardig' leveren u een ip-ban op,
          u bent niet welkom. Het kan ons ook niet schelen dat u een video
          al eerder op Facebook, Hyves of de Whatsapp-groep van ome Henk
          heeft gezien. Als u de content al kent, waarom klikt u er dan op?
          Ga weg.
        </p>

        <h3>Herhalio's</h3>
        <p>
          Autisten die eerdere reacties niet lezen maar vooral hun eigen
          reaguursel terug willen zien. Dit is uitermate saai voor andere
          bezoekers. Ook het oeverloos herhalen van eerder geplaatste
          reaguursels (het zogenaamde flooden) is verboden.
        </p>

        <h3>Sexueel gefrustreerden</h3>
        <p>
          Vrouwelijke bezoekers stellen we erg op prijs. Laaghartige
          aanvallen in schuttingtaal, puur vanwege het feit dat een
          reaguurder zich bekend maakt als vrouw tolereren we niet. Aan
          seksueel gefrustreerde reaguurders hebben we geen behoefte. Zeker
          niet als bezoeksters en hun reactie door ons w&eacute;l gewaardeerd
          worden. Teen +1 maar geen penisnijd op Dumpert!
        </p>

        <h3>Dombo's</h3>
        <p>
          Nietszeggende reacties. 'first', 'ja, het is me wat', 'Dat is
          belachelijk!!' of 'Dat dit in Nederland mogelijk is', u snapt het
          wel. Domme, inhoudsloze, niet vermakelijke commentaren. Zeker als
          ze meerdere malen voor komen en het duidelijk is dat u de
          voorgaande reacties niet leest. Het is saai voor ons en voor de
          rest, we sturen u terug naar Fok!
        </p>

        <h3>Slimmeriken</h3>
        <p>
          Het posten van priv&eacute;-gegevens die iedereen toch wel kan vinden is
            niet stoer. Dumpert is geen telefoonboek. Niet doen dus.
        </p>

        <h2>Uitgebreidere toelichting</h2>

        <h3>Taalgebruik</h3>
        <p>
          We verwachten correct en foutloos Nederlands. Wie de taal niet
          beheerst, verzoeken we niet te reageren. Reacties in tenenkrommend
          Nederlands halen we weg en u krijgt een ip-ban. Een uitzondering
          geldt voor niet-native Dutch speakers en dyslectische mensen.
          Meestal gaat het hebben van een niet-boeiende reactie echter samen
          met slecht taalgebruik.
        </p>

        <h3>Over ip-nummers</h3>
        <p>
          Uw ip-nummer is het unieke nummer waaraan u door politie en soms
          door de redactieleden van Dumpert te traceren en te identificeren
          bent. Dit nummer verschijnt niet bij uw reactie, bij de meeste
          fora en logs gebeurt dit al wel. Dat betekent niet dat we het
          nummer niet registreren en tijdelijk opslaan. Bij het overtreden
          van eerder genoemde regels staat het ons vrij uw ip-nummer w&eacute;l
          bij uw reactie te zetten. Net als uw e-mailadres.
        </p>

        <h3>Reposts</h3>
        <p>
          Reposts zijn vervelend, maar er kan er altijd eentje tussen door
          sluipen. Wees niet bang om 'repost' te roepen in de reaguursels.
          De upload zal vanzelf worden verwijderd. Maar let op: 'repost'
          roepen terwijl het geen repost betreft kan u op een -weggejorist-
          komen te staan. Ter verduidelijking: 'Hitler in de tram', dat
          dikke wijf dat op Homer Simpson lijkt en alle dolfijnenslachtingen
          zijn al eens eerder gepost.
        </p>

        <h3>Over discussie</h3>
        <p>
          Dumpert is ons speeltje. We maken het ter onzer en uwer vermaak
          (in die volgorde). Niets meer, niets minder. Dagelijks komen er
          bakken leuke content online. Gratis. Zeuren over reclame is
          zinloos, tenzij u een paar miljoen euro aan ons wilt schenken. We
          hebben niet altijd evenveel tijd voor diepgaande discussies hoe
          graag we dit ook willen. Denk dus even na voordat je begint te
          ranten.
        </p>

        <h3>Hengelen naar plusjes</h3>
        <p>
          We hebben er een hekel aan als u schaamteloos anderen oproept om
          iets te gaan minnen of plussen. Dat geldt zowel voor topics als
          (eigen) reaguursels. Bedenk dat uw medereaguurder zelf wel kan
          beslissen of hij iets de moeite waard vindt.
        </p>

        <h3>Offtopic</h3>
        <p>
          Offtopic reaguursels worden hooguit gedoogd. Het is aan het humeur
          van de moderator of deze blijven staan. Mocht u zich hier vaak
          schuldig aan maken kan dat u een ban opleveren.
        </p>

        <h3>Huilebalken</h3>
        <p>
          Dumpert is niet voor mietjes, we hebben een grondige hekel aan
          gejammer, gepiep en politiek correct gedrag. We hebben simpelweg
          geen tijd om aandacht te besteden aan kleinzielig gejammer. We
          zijn het heus niet altijd eens met de inhoud van filmpjes, maar
          het boeit ons niks dat u geschokt bent vanwege een dode kitten of
          een gewelddadige faceplant. Wees zakelijk en duidelijk in uw
          communicatie, dan doen wij dat ook! Zo lossen we problemen het
          snelste op.
        </p>

        <h3>Gezeur</h3>
        <p>
          Het boeit ons niet als je Dumpert stom, saai, vroeger beter en/of
          niet cohesie bevorderend vindt. Als je niet van filmpjes houdt of
          hier niet meer wil komen: hou de eer aan jezelf en vertrek.
        </p>

        <h3>Flamen</h3>
        <p>
          Flamen is leuk, als het maar vermakelijk is! Doe dus uw best. Een
          ordinaire scheldpartij is geen flame, u loopt het risico op een
          ban.
        </p>

        <h3>Bedreigingen</h3>
        <p>
          Met semi-geestige nekschoten en (fictieve) doodsbedreigingen
          begeeft u zich op zeer glad ijs. Ja, wij weten dat het grappig
          bedoeld is. Uw medereaguursels moeten er wellicht ook hartelijk om
          lachen. Maar de werkelijkheid is dat de rechter alleen kijkt naar
          hoe uw 'slachtoffer' zich voelt en niet hoe u uw doodsbedreiging
          instak. Ten strengste verboden dus. Als het echt nodig is, doe
          (doods)bedreigingen dan alleen met wederzijdse instemming,
          eventueel onder het genot van een biertje. Een ironieteken kan
          veel ellende voorkomen!
        </p>

        <h3>Stalken</h3>
        <p>
          Gefrustreerde nobodies die denken dat ze dodenlijsten kunnen
          aanleggen, medewerkers en/of gebruikers van Dumpert kunnen
          stalken, bedreigen en/of lastigvallen hebben aan ons een
          verkeerde. Hierin zijn we genadeloos. We leggen een dossiertje van
          jullie klootzakjes aan en zullen samen met politie/justitie u tot
          aan de poorten van de hel achtervolgen. Dit menen we serieus:
          Veiligheid van het personeel staat bij ons hoog in het vaandel.
          Wees dus gewaarschuwd.
        </p>
        <p>
          Tere zieltjes die in de reaguursels lopen te miepen en vervolgens
          gaan klagen dat ze hard aangepakt worden, moeten Dumpert simpelweg
          mijden.?
        </p>
        <p>
          Bedreig never-nooit-niet prominente personen of onderwerpen die op
          Dumpert figureren. Dat levert u sowieso een permaban en in het
          ergste geval een arrestatie op!
        </p>

        <h3>Klachtencommissie</h3>
        <p>
          Heeft u een ip-ban op Dumpert te pakken? U kan ons uw bezwaren
          mailen en dan komen we er samen wel uit!
        </p>

        <h3>Over uploaden</h3>
        <p>
          Hartelijk dank voor je dump! Behalve als je ons gehackt / gestolen
          / of anderszins onrechtmatig (verkregen) beeldmateriaal opstuurt.
          Daar zitten we absoluut niet op te wachten. Het is overigens tegen
          de wet om gestolen materiaal, bijvoorbeeld die naaktfoto uit de
          dropbox van je moeder, verder te verspreiden, dus wees
          gewaarschuwd. Voor uitgebreidere info over voorwaarden voor
          uploaders klik <a href="https://assets.dumpert.nl/algemene-gebruiksvoorwaarden-dtmedia.pdf" target="_blank" rel="noopener noreferrer">HIERRR</a>.
        </p>

        <h3>Tot slot</h3>
        <p>
          De huisregels kunnen op ieder moment naar goeddunken van de
          redactie ter plekke aangepast worden. Beroepen op de regels is
          derhalve zinloos, wij hebben altijd gelijk.
        </p>
      </div>
    </div>
    <ScrollToTopButton />
  </>
);
